import { UsMktListPage, UsMktEditPage, UsMktCreatePage } from './imports';

export const usMktRoutes = [
  {
    path: 'us-mkt',
    children: [
      {
        element: <UsMktListPage />,
        index: true,
      },
      {
        path: 'list',
        element: <UsMktListPage />,
      },
      {
        path: ':id/edit',
        element: <UsMktEditPage />,
      },
      {
        path: 'new',
        element: <UsMktCreatePage />,
      },
    ],
  },
];
